/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export type ErrorHandlerResult = Promise<Error | void> | Error | void;

export type ErrorHandlerFunction<E extends Error = Error> = (error: E) => ErrorHandlerResult;

export type ErrorMapper = (reponse: Response) => Error;

export type GetErrorResponses<T,S> = Exclude<Awaited<T>, JSONApiResponse<S>>;

export type ErrorResponse<T> = T extends JSONApiResponse ? ResponseError<T> : never;

export type ApiErrorUnion<R, S> = ErrorResponse<GetErrorResponses<R,S>> | FetchError | UnknownError;

export type GetR<T> = T extends JSONApiResponse<infer R, infer _N> ? R : UnknownError;
export type GetN<T> = T extends JSONApiResponse<infer _R, infer N> ? N extends string ? N : "ResponseError"
: "ResponseError";

export type HandledResponse<S, R extends Promise<JSONApiResponse | VoidApiResponse | BlobApiResponse> = Promise<JSONApiResponse>> = {
  success: true;
  result: S;
  error: undefined;
  raw: Response;
} | {
    success: false;
    result: undefined;
    error: ApiErrorUnion<R,S>;
    raw?: Response;
}

export type HandleFunction = <S,R extends Promise<JSONApiResponse | VoidApiResponse | BlobApiResponse>>(promise: R, errorHandlers?: Array<(error: ApiErrorUnion<R,S>) => ErrorHandlerResult>, errorMapper?: ErrorMapper ) => Promise<HandledResponse<S, R>>;

export function hasEmptyBody(response: Response): boolean {
    return response.status === 204 ||
           response.headers.get('content-length') === '0' ||
           (!response.headers.get('content-length') && response.status >= 200 && response.status < 300);
}

export const defaultHandleFunction: HandleFunction = async <S,R extends Promise<JSONApiResponse | VoidApiResponse | BlobApiResponse>>(promise: R): Promise<HandledResponse<S, R>> => {
    try {
        const response = await promise;
        const result = await response.value();

        if (response && response.raw.status >= 200 && response.raw.status < 300) {
          return { success: true, result: result as S, error: undefined, raw: response.raw };
        } else {
          const error = (await ResponseError.create(response)) as ErrorResponse<GetErrorResponses<R,S>>;
          return { success: false, result: undefined, error, raw: response.raw };
        }
    } catch (error) {
        return {success: false ,result: undefined, error: new UnknownError(error as Error) }
    }
}

export interface ConfigurationParameters {
    basePath?: string; // override base path
    fetchApi?: FetchAPI; // override for fetch implementation
    middleware?: Middleware[]; // middleware to apply before/after fetch requests
    queryParamsStringify?: (params: HTTPQuery) => string; // stringify function for query strings
    username?: string; // parameter for basic security
    password?: string; // parameter for basic security
    apiKey?: string | Promise<string> | ((name: string) => string | Promise<string>); // parameter for apiKey security
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string | Promise<string>); // parameter for oauth2 security
    headers?: HTTPHeaders; //header params we want to use on every request
    credentials?: RequestCredentials; //value for the credentials param we want to use on each request
    handleFunction?: <S,R extends Promise<JSONApiResponse | VoidApiResponse | BlobApiResponse>>(promise: R, errorHandlers?: Array<(error: ApiErrorUnion<R,S>) => ErrorHandlerResult>, errorMapper?: ErrorMapper ) => Promise<HandledResponse<S, R>>;
}

export class Configuration {
    constructor(private configuration: ConfigurationParameters = {}) {}

    set config(configuration: Configuration) {
        this.configuration = configuration;
    }

    get basePath(): string {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }

    get fetchApi(): FetchAPI | undefined {
        return this.configuration.fetchApi;
    }

    get middleware(): Middleware[] {
        return this.configuration.middleware || [];
    }

    get queryParamsStringify(): (params: HTTPQuery) => string {
        return this.configuration.queryParamsStringify || querystring;
    }

    get username(): string | undefined {
        return this.configuration.username;
    }

    get password(): string | undefined {
        return this.configuration.password;
    }

    get apiKey(): ((name: string) => string | Promise<string>) | undefined {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : () => apiKey;
        }
        return undefined;
    }

    get accessToken(): ((name?: string, scopes?: string[]) => string | Promise<string>) | undefined {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : async () => accessToken;
        }
        return undefined;
    }

    get headers(): HTTPHeaders | undefined {
        return this.configuration.headers;
    }

    get credentials(): RequestCredentials | undefined {
        return this.configuration.credentials;
    }

    get handleFunction(): HandleFunction {
        return this.configuration.handleFunction || defaultHandleFunction;
    }
}

export const DefaultConfig = new Configuration();

/**
 * This is the base class for all generated API classes.
 */
export class BaseAPI {

    private static readonly jsonRegex = new RegExp('^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$', 'i');
    private middleware: Middleware[];

    constructor(protected configuration = DefaultConfig) {
        this.middleware = configuration.middleware;
    }

    withMiddleware<T extends BaseAPI>(this: T, ...middlewares: Middleware[]) {
        const next = this.clone<T>();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }

    withPreMiddleware<T extends BaseAPI>(this: T, ...preMiddlewares: Array<Middleware['pre']>) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware<T>(...middlewares);
    }

    withPostMiddleware<T extends BaseAPI>(this: T, ...postMiddlewares: Array<Middleware['post']>) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware<T>(...middlewares);
    }

    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    protected isJsonMime(mime: string | null | undefined): boolean {
        if (!mime) {
            return false;
        }
        return BaseAPI.jsonRegex.test(mime);
    }

    protected async request(context: RequestOpts, initOverrides?: RequestInit | InitOverrideFunction): Promise<Response> {
        const { url, init } = await this.createFetchParams(context, initOverrides);
        return await this.fetchApi(url, init);
    }

    private async createFetchParams(context: RequestOpts, initOverrides?: RequestInit | InitOverrideFunction) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }

        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach(key => headers[key] === undefined ? delete headers[key] : {});

        const initOverrideFn =
            typeof initOverrides === "function"
                ? initOverrides
                : async () => initOverrides;

        const initParams = {
            method: context.method,
            headers,
            body: context.body,
            credentials: this.configuration.credentials,
        };

        const overriddenInit: RequestInit = {
            ...initParams,
            ...(await initOverrideFn({
                init: initParams,
                context,
            }))
        };

        let body: any;
        if (isFormData(overriddenInit.body)
            || (overriddenInit.body instanceof URLSearchParams)
            || isBlob(overriddenInit.body)) {
          body = overriddenInit.body;
        } else if (this.isJsonMime(headers['Content-Type'])) {
          body = JSON.stringify(overriddenInit.body);
        } else {
          body = overriddenInit.body;
        }

        const init: RequestInit = {
            ...overriddenInit,
            body
        };

        return { url, init };
    }

    private fetchApi = async (url: string, init: RequestInit) => {
        let fetchParams = { url, init };
        for (const middleware of this.middleware) {
            if (middleware.pre) {
                fetchParams = await middleware.pre({
                    fetch: this.fetchApi,
                    ...fetchParams,
                }) || fetchParams;
            }
        }
        let response: Response | undefined = undefined;
        try {
            response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
        } catch (e) {
            for (const middleware of this.middleware) {
                if (middleware.onError) {
                    response = await middleware.onError({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        error: e,
                        response: response ? response.clone() : undefined,
                    }) || response;
                }
            }
            if (response === undefined) {
              if (e instanceof Error) {
                throw new FetchError(e, 'The request failed and the interceptors did not return an alternative response');
              } else {
                throw e;
              }
            }
        }
        for (const middleware of this.middleware) {
            if (middleware.post) {
                response = await middleware.post({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    response: response.clone(),
                }) || response;
            }
        }
        return response;
    }

    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    private clone<T extends BaseAPI>(this: T): T {
        const constructor = this.constructor as any;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
};

function isBlob(value: any): value is Blob {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}

function isFormData(value: any): value is FormData {
    return typeof FormData !== "undefined" && value instanceof FormData;
}

// Development-only check that a response's declared `dtoName` (from the OpenAPI schema, via
// apis.mustache) agrees with the parsed body's own `$type` field. Catches a backend
// `ErrorResponse.Create` switch falling out of sync with its own exception hierarchy (see
// ErrorResponse.cs's "keep this switch in sync" comment) at the moment it first occurs, in any
// developer's local session. `import.meta.env.DEV` is statically eliminated by the bundler in
// production builds, so this has zero production cost.
function bodyTypeMatchesDtoName(bodyType: string, dtoName: string): boolean {
    // bodyType is the body's own raw $type, a full .NET type string, e.g.
    // "Ptw.Ptw100...Exceptions.Ptw100BadRequestException, Ptw.Ptw100.AppZero.Core.Shared".
    // dtoName is the generated literal name, e.g. "ErrorResponseOfPtw100BadRequestException".
    // No generated-model import here (would be circular: models import from this file) - a
    // dependency-free substring check is enough for a dev-only diagnostic.
    const exceptionClassName = dtoName.replace(/^ErrorResponseOf/, '');
    return bodyType.includes(`.${exceptionClassName},`);
}

export class ResponseError<R extends JSONApiResponse | VoidApiResponse | BlobApiResponse> extends Error {
		private constructor(public response: Response, public error: GetR<R> | undefined = undefined, public override name: GetN<R> | "ResponseError" = "ResponseError") {
        super();
        this.name = name;
    }

    static async create<R extends JSONApiResponse | VoidApiResponse | BlobApiResponse>(response: R) {
        try {
          if (response instanceof JSONApiResponse) {
            const value = await response.value() as GetR<R>;
            if (import.meta.env.DEV && response.dtoName) {
              const bodyType = (value as { $type?: string } | undefined)?.$type;
              if (bodyType && !bodyTypeMatchesDtoName(bodyType, String(response.dtoName))) {
                console.error(
                  `ResponseError name/body mismatch: declared '${response.dtoName}' but body $type is '${bodyType}'. ` +
                  `Likely a backend ErrorResponse.Create switch gap - see ErrorResponse.cs.`,
                );
              }
            }
            return new ResponseError(response.raw.clone(), value, response.dtoName as GetN<R>);
          } else {
            return new ResponseError(response.raw.clone(), await response.value() as GetR<R>);
          }
        } catch (error) {
          console.error('Error parsing JSON from error response', error);
          return new ResponseError(response.raw.clone(), undefined, "ResponseError");
        }
		}
}

export class UnknownError extends Error {
    override name: "UnknownError" = "UnknownError";
    constructor(public cause: Error) {
        super(cause.message);
    }
}

export class FetchError extends Error {
    override name: "FetchError" = "FetchError";
    constructor(public cause: Error, msg?: string) {
        super(msg);
    }
}

export class RequiredError extends Error {
    override name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export type FetchAPI = WindowOrWorkerGlobalScope['fetch'];

export type Json = any;
export type HTTPMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'HEAD';
export type HTTPHeaders = { [key: string]: string };
export type HTTPQuery = { [key: string]: string | number | null | boolean | Array<string | number | null | boolean> | Set<string | number | null | boolean> | HTTPQuery };
export type HTTPBody = Json | FormData | URLSearchParams;
export type HTTPRequestInit = { headers?: HTTPHeaders; method: HTTPMethod; credentials?: RequestCredentials; body?: HTTPBody };
export type ModelPropertyNaming = 'camelCase' | 'snake_case' | 'PascalCase' | 'original';

export type InitOverrideFunction = (requestContext: { init: HTTPRequestInit, context: RequestOpts }) => Promise<RequestInit>

export interface FetchParams {
    url: string;
    init: RequestInit;
}

export interface RequestOpts {
    path: string;
    method: HTTPMethod;
    headers: HTTPHeaders;
    query?: HTTPQuery;
    body?: HTTPBody;
}

export function exists(json: any, key: string) {
    const value = json[key];
    return value !== null && value !== undefined;
}

export function querystring(params: HTTPQuery, prefix: string = ''): string {
    return Object.keys(params)
        .map(key => querystringSingleKey(key, params[key], prefix))
        .filter(part => part.length > 0)
        .join('&');
}

function querystringSingleKey(key: string, value: string | number | null | undefined | boolean | Array<string | number | null | boolean> | Set<string | number | null | boolean> | HTTPQuery, keyPrefix: string = ''): string {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
            .join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) {
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    }
    if (value instanceof Object) {
        return querystring(value as HTTPQuery, fullKey);
    }
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}

export function mapValues(data: any, fn: (item: any) => any) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  );
}

export function canConsumeForm(consumes: Consume[]): boolean {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}

export interface Consume {
    contentType: string;
}

export interface RequestContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
}

export interface ResponseContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
    response: Response;
}

export interface ErrorContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
    error: unknown;
    response?: Response;
}

export interface Middleware {
    pre?(context: RequestContext): Promise<FetchParams | void>;
    post?(context: ResponseContext): Promise<Response | void>;
    onError?(context: ErrorContext): Promise<Response | void>;
}

export interface ApiResponse<S,E = unknown> {
    raw: Response;
    value(): Promise<S | E>;
}

export interface ResponseTransformer<T> {
    (json: any): T;
}

export class JSONApiResponse<T = unknown,N = unknown> {
    constructor(public raw: Response, private transformer: ResponseTransformer<T> = (jsonValue: any) => jsonValue, public dtoName?: N) {}

    async value(): Promise<T> {
        return this.transformer(await this.raw.clone().json());
    }
}

export class VoidApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<void> {
        return undefined;
    }
}

export class BlobApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<Blob> {
        return await this.raw.blob();
    };
}

export class TextApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<string> {
        return await this.raw.text();
    };
}

// $type discriminator needs to serialized as first property of objects
// by requirement of Newtonsoft to be deserializable correctly
// https://www.newtonsoft.com/json/help/html/SerializationSettings.htm#TypeNameHandling
export function typeFirst(body: object) {
    if (body.hasOwnProperty("$type")) {
        return Object.fromEntries(Object.entries(body).sort((a,b) => {
            if (a[0] === "$type") return -1;
            else if (b[0] === "$type") return 1;
            else return 0;
        }))
    } else {
        return body
    }
};
